import React, { useState, useEffect, useCallback } from 'react';

const LAYER_CONFIG = {
  zonespol: { name: 'ЗООР', visible: false },
  zninspol: { name: 'ЗНиНС', visible: false },
  oopt: { name: 'ООПТ', visible: false },
  admpol: { name: 'Административные границы', visible: false },
  dtplin: { name: 'ДТП линии', visible: false },
  dtppnt: { name: 'ДТП точки', visible: false }
};

function LayerControl({ apiUrl, layerManagerRef }) {
  const [layers, setLayers] = useState(LAYER_CONFIG);
  const [loading, setLoading] = useState({});
  const layerManager = layerManagerRef?.current;

  // Загрузка слоев с видимостью по умолчанию при монтировании
  useEffect(() => {
    if (!layerManager) return;

    const loadDefaultLayers = async () => {
      const defaultLayers = Object.entries(LAYER_CONFIG)
        .filter(([_, config]) => config.visible);
      
      const loadPromises = defaultLayers.map(async ([layerId]) => {
        setLoading(prev => ({ ...prev, [layerId]: true }));
        try {
          const success = await layerManager.loadLayer(layerId, true);
          if (!success) {
            // Если слой не загрузился, сбрасываем видимость
            setLayers(prev => ({
              ...prev,
              [layerId]: { ...prev[layerId], visible: false }
            }));
          }
        } catch (error) {
          console.error(`Error loading default layer ${layerId}:`, error);
          setLayers(prev => ({
            ...prev,
            [layerId]: { ...prev[layerId], visible: false }
          }));
        } finally {
          setLoading(prev => ({ ...prev, [layerId]: false }));
        }
      });

      await Promise.all(loadPromises);
    };

    loadDefaultLayers();
  }, [layerManager]); // Загружаем только при монтировании layerManager

  const handleLayerToggle = useCallback((layerId) => {
    const currentLayerManager = layerManagerRef?.current;
    if (!currentLayerManager) return;
    
    const currentVisible = layers[layerId].visible;
    const newVisible = !currentVisible;
    
    // Обновляем состояние видимости
    setLayers(prev => ({
      ...prev,
      [layerId]: {
        ...prev[layerId],
        visible: newVisible
      }
    }));

    if (newVisible) {
      // Включаем слой - проверяем существует ли, если нет - загружаем
      const layerExists = currentLayerManager.toggleLayerVisibility(layerId, true);
      if (!layerExists) {
        // Слой не существует, загружаем его
        setLoading(prev => ({ ...prev, [layerId]: true }));
        currentLayerManager.loadLayer(layerId, true)
          .then(success => {
            if (!success) {
              // Если загрузка не удалась, сбрасываем видимость
              setLayers(prev => ({
                ...prev,
                [layerId]: { ...prev[layerId], visible: false }
              }));
            }
          })
          .catch(error => {
            console.error(`Error loading layer ${layerId}:`, error);
            setLayers(prev => ({
              ...prev,
              [layerId]: { ...prev[layerId], visible: false }
            }));
          })
          .finally(() => {
            setLoading(prev => ({ ...prev, [layerId]: false }));
          });
      }
    } else {
      // Выключаем слой - просто скрываем
      currentLayerManager.toggleLayerVisibility(layerId, false);
    }
  }, [layerManagerRef, layers]);

  return (
    <div className="layer-control">
      <h4>Слои</h4>
      <div className="layer-list">
        {Object.entries(layers).map(([layerId, config]) => (
          <div key={layerId} className="layer-item">
            <label>
              <input
                type="checkbox"
                checked={config.visible}
                onChange={() => handleLayerToggle(layerId)}
                disabled={loading[layerId]}
              />
              <span>{config.name}</span>
              {loading[layerId] && <span className="loading">Загрузка...</span>}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}

export default LayerControl;
